export const JobTypeList =
[
    {Id:"Liaisoning Officer" ,Name:"Liaisoning Officer"},
    {Id:"Finance Officer" ,Name:"Finance Officer"},
    {Id:"Care Taker" ,Name:"Care Taker"},
    {Id:"Cook" ,Name:"Cook"},
    {Id:"Metron" ,Name:"Metron"},
    {Id:"Hostel in Charge" ,Name:"Hostel in Charge"},
    {Id:"Driver" ,Name:"Driver"},
    {Id:"Warden" ,Name:"Warden"},
    {Id:"DEO" ,Name:"DEO"},
    {Id:"Clerk" ,Name:"Clerk"},
    {Id:"Security" ,Name:"Security"}
    ]
    
    export default JobTypeList;
    